/** In-App Purchase configuration */

import type { CellPackProduct } from '../types/config';
export type { CellPackProduct };

export const REVENUECAT_CONFIG = {
  ios: 'appl_aGqyRBAboOIbJQjQMHfUZBDZnRv',
  android: 'goog_RudRgIgPqPyDDjrxvntiTCWeMaa',
};

/** Cell pack products — 기본값 (Firestore appConfig에 cellPacks가 없을 때 사용) */
export const CELL_PACKS: CellPackProduct[] = [
  {
    id: 'cellpack1000',
    androidId: 'cellpack1000',
    iosId: 'cellpack1000K',
    cells: 1_000_000,
    label: { ko: '1,000K 셀팩', en: '1,000K Cell Pack' },
  },
  {
    id: 'cellpack5000',
    androidId: 'cellpack5000',
    iosId: 'cellpack5000K',
    cells: 5_000_000,
    label: { ko: '5,000K 셀팩', en: '5,000K Cell Pack' },
  },
  {
    id: 'cellpack10000',
    androidId: 'cellpack10000',
    iosId: 'cellpack10000K',
    cells: 10_000_000,
    label: { ko: '10,000K 셀팩', en: '10,000K Cell Pack' },
  },
];
